import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import BtnBgPlum70Dialog from "./btn/btn-bg-plum-70-dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

type DialogProps = {
  show: boolean;
  onClose: () => void;
  buttonText: string;
  redirectTo: string;
  children?: React.ReactNode;
};

const Dialog: React.FC<DialogProps> = ({
  show,
  onClose,
  buttonText,
  redirectTo,
  children,
}) => {
  const dialogRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dialogRef.current &&
        !dialogRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      className="position-fixed top-0 start-0 vw-100 vh-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 p-4"
      style={{ zIndex: 100 }}
    >
      <div
        ref={dialogRef}
        className="bg-white p-4 rounded shadow "
        style={{
          borderTop: "12px solid var(--divelit-plum)",
          maxWidth: "720px",
        }}
      >
        <div className="d-flex flex-column align-items-end m-0">
          <button
            onClick={onClose}
            className="bg-none paragraph-small d-flex align-items-center border-none p-0"
          >
            <FontAwesomeIcon icon={faXmark} className="fa-solid fa-x" />
          </button>
        </div>
        <div className="mb-5">{children}</div>
        <div className="d-flex flex-column align-items-end">
          <BtnBgPlum70Dialog
            onClick={() => {
              onClose();
              navigate(redirectTo);
            }}
            buttonText={buttonText}
          ></BtnBgPlum70Dialog>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
